export const USER_RIGHTS = {
    ADMIN: 1,
    CONSIGNEE: 2,
    COSG: 3,
    SSE_ADMIN: 4,
    ACCOUNTS: 5,
    SSEI: 6
}

export const REPORT_TYPE={
    PO_NOT_GENERATED :1,
    ITEM_NOT_RECEIVED :2,
    SUITABILITY_PENDING : 3,
    BILL_RECEIVED_PENDING:4,
    BILL_PASSING_PENDING :5,
    CRN_PENDING :6,
    PAYMENT_PENDING :7,
    PAID:8,
    USER_LIST:9,
    PO_CANCELED:10,
}

export const TOASTER_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warning',
}

export const DATE_FORMAT = 'DD-MMM-YYYY';

export const DISPLAY_PAGE_SIZE=10;
//export const API_BASE_URL = 'https://po.sriyansh.co.in';
export const API_BASE_URL = 'https://ns.mwsgkp.in'
//export const API_BASE_URL = 'https://ns.srv851107.hstgr.cloud';